import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { AcquirerEntity } from "src/app/features/Acquirer/types/AcquirerEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { contractBaseSelectConfig, statusSelectorConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const AcquirersSearchForm: FC<SearchFormProps<AcquirerEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("acquirerSearchForm.criteriaBadges.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("acquirerSearchForm.criteriaBadges.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item name="status" label={t("acquirerSearchForm.criteriaBadges.status")}>
                <SelectDynamic name="status" label={t("acquirerSearchForm.criteriaBadges.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
            <Form.Item name="discriminator" label={t("contractSearchForm.criteriaBadges.virtualDiscriminator")}>
                <SelectDynamic
                    name="discriminator"
                    label={t("contractSearchForm.criteriaBadges.virtualDiscriminator")}
                    fieldConfig={contractBaseSelectConfig}
                />
            </Form.Item>
        </SearchForm>
    );
};
